import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { Delete, History } from "@mui/icons-material";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import StlapFooter from "../CustomComponents/StlapFooter";
import CustomButton from "../CustomComponents/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import CustomDateField from "../CustomComponents/CustomDateField";
import axios from "axios";
import CustomConfirmationDialog from "../CustomComponents/CustomConfirmationDialog";
import "./CashHandlingCharge.css";
import CustomSnackBar from "../CustomComponents/CustomSnackBar";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import dayjs from "dayjs";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import store from "../Store";
const CashHandlingCharge = () => {
  const [effectiveDate, setEffectiveDate] = useState("");
  const [snackBarMessage, setSnackBarMessage] = useState("range missmatch");
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [datarows, setDatarows] = useState([]);
  const [modifiedMaps, setModifiedmap] = React.useState({});
  const [effectiveDateIsTouched, setEffectiveDateIsTouched] = useState(false);
  const [discardDialogOpen, setDiscardDialogOpen] = useState(false);
  const [discardDateValue, setDiscardDateValue] = useState("");
  const [dueValidDateToError, setDueValidDateToError] = useState(false);
  const [prevEffectiveDate, setPrevEffectiveDate] = useState("");
  // const [voucherValidDateError, setVoucherValidDateError] = useState(false);
  // const [voucherDateHasError, setVoucherDateHasError] = useState(false);
  //State for checking date validations
  let today = new Date();
  let givenYear = new Date(effectiveDate).getFullYear();
  let givenMonth = new Date(effectiveDate).getMonth() + 1; // Adding 1 because month is zero-based
  let givenDay = new Date(effectiveDate).getDate();

  // Extract year, month, and day values from today's date
  let todayYear = today.getFullYear();
  let todayMonth = today.getMonth() + 1;
  let todayDay = today.getDate();

  let effectiveDateDateValidationFlag;
  if (givenYear > todayYear) {
    effectiveDateDateValidationFlag = true;
  } else if (givenYear === todayYear && givenMonth > todayMonth) {
    effectiveDateDateValidationFlag = true;
  } else if (
    givenYear === todayYear &&
    givenMonth === todayMonth &&
    givenDay >= todayDay
  ) {
    effectiveDateDateValidationFlag = true;
  } else {
    effectiveDateDateValidationFlag = false;
  }

  const userName = useSelector((state) => state.branch.userName);
  const dispatch = useDispatch();
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  let paramValues = useSelector((state) => state.specialAccess.paramValues);

  const [cashHandlingOverviewGridRows, setCashHandlingRecordsOverviewGridRows] =
    useState([]);
  const [
    cashHandlingOverviewGridColumns,
    setCashHandlingRecordsOverviewGridColumns,
  ] = useState([]);
  const [cashHandlingRecordsOverviewDlg, setCashHandlingRecordsOverviewDlg] =
    useState(false);

  //Branch onChangeHandler
  useEffect(() => {
    getFieldData();
  }, []);

  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };

  let minDateFromValue = Number(0);
  let maxDateFromValue = Number(0);
  if (
    paramValues !== null &&
    paramValues !== undefined &&
    Object.keys(paramValues).length > 0
  ) {
    if (
      !(
        paramValues["Cash Handling Request Date Back Count"] &&
        new Date(
          paramValues["Cash Handling Request Date Back Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Cash Handling Request Date Back Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      minDateFromValue = 0;
    } else {
      minDateFromValue =
        fieldAccessMap.cashHandlingEffectiveDate &&
        fieldAccessMap.cashHandlingBackCount
          ? Number(
              paramValues["Cash Handling Request Date Back Count"]["paramValue"]
            )
          : Number(0);
    }
    if (
      !(
        paramValues["Cash Handling Request Date Future Count"] &&
        new Date(
          paramValues["Cash Handling Request Date Future Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Cash Handling Request Date Future Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateFromValue = 0;
    } else {
      maxDateFromValue =
        fieldAccessMap.cashHandlingEffectiveDate &&
        fieldAccessMap.cashHandlingFutureCount
          ? Number(
              paramValues["Cash Handling Request Date Future Count"][
                "paramValue"
              ]
            )
          : Number(0);
    }
  }
  const effectiveDateIsValid =
    new Date(effectiveDate).toDateString() !== "Invalid Date" &&
    effectiveDate !== null &&
    new Date(effectiveDate).toLocaleDateString().slice(-4) >= "1970" &&
    new Date(effectiveDate).toLocaleDateString().slice(-4) <= "2055" &&
    effectiveDateDateValidationFlag;
  const effectiveDateHasError = effectiveDateIsTouched && !effectiveDateIsValid;
  const effectiveDateEmpty =
    effectiveDateIsTouched && (effectiveDate === "" || effectiveDate === null);
  //shortcut key

  const searchButtonRef = useRef(null);
  const clearRef = useRef(null);
  const saveRef = useRef(null);
  const addRowRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "cashHandlingCharge",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let date = new Date();
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let refList = {
      clearRef: clearRef,
      searchButtonRef: searchButtonRef,
      saveRef: saveRef,
      addRowRef: addRowRef,
    };
    if (event.ctrlKey) {
      if (charCode === "i") {
        setEffectiveDate(date);
      } else if (charCode === "o") {
        date.setDate(date.getDate() + 1);
        setEffectiveDate(date);
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "cashHandlingCharge",
          })
        );
      }
    }
  };
  useEffect(() => {
    let newRow = {
      id: 0,
      fromReceiptAmt: 0,
      toReceiptAmt: "",
      cashHandlingCharges: "",
      denomination: "",
    };
    let newList = [];
    newList.push(newRow);
    setDatarows(newList);
    setTotalPageCount(
      datarows.length % 10 !== 0
        ? Number(Number((datarows.length / 10).toFixed()) + 1)
        : Number(Number((datarows.length / 10).toFixed()))
    );
    setTotalRowsCount(datarows.length);
    setPage(1);
  }, []);
  const handleCellEditDisable = (event) => {
    console.log(event);
  };
  const onSaveButtonClickHandler = async () => {
    const dataMap = {};
    datarows.forEach((map, index) => {
      map["createdBy"] = userName;
      map["effectiveDate"] = effectiveDate;
      map["lastModifiedBy"] = lastModifiedBy;
    });
    dataMap["cashHandlingData"] = datarows;
    dataMap["historyData"] = historySet;
    dataMap["effectiveDate"] = new Date(effectiveDate).toLocaleDateString(
      "fr-FR"
    );
    try {
      const response = await axios.post(
        "/cashHandlingCharges/insertCashHandlingCharges",
        dataMap
      );
      if (response.data === "saved") {
        setCashSavedDialogOpen(true);
      } else {
        setCashSavedDialogOpen(false);
      }
    } catch {
      console.log("Network Error");
    }
  };
  const columns = [
    {
      field: "id",
      headerName: "S.No",
      headerAlign: "center",
      align: "left",
      flex: 1,
      editable: false,
      hide: true,
    },
    {
      field: "fromReceiptAmt",
      headerName: "From Receipt Amount (₹)",
      headerAlign: "center",
      align: "right",
      flex: 280,
      type: "number",
      editable: false,
    },
    {
      field: "toReceiptAmt",
      headerName: "To Receipt Amount (₹)",
      headerAlign: "center",
      align: "right",
      flex: 280,
      type: "number",
      editable: true,
      valueGetter: (value) => {
        if (value.value < 0 || value.value > 99999999) {
          return 0;
        } else {
          if (
            value.value <= value.row.fromReceiptAmt &&
            datarows[value.id + 1] &&
            !datarows[value.id + 1]["fromReceiptAmt"] >= value.value
          ) {
            return 0;
          } else {
            return value.value;
          }
        }
      },
      renderCell: (params) => {
        return params.value !== null
          ? parseInt(params.value).toLocaleString("en-IN")
          : 0;
      },
    },
    {
      field: "cashHandlingCharges",
      headerName: "Cash Handling Charges (₹)",
      headerAlign: "center",
      align: "right",
      flex: 280,
      type: "number",
      editable: true,
      valueGetter: (value) => {
        if (value.value <= 0 || value.value > 99999999) {
          return 0;
        } else {
          return value.value;
        }
      },
      renderCell: (params) => {
        return parseInt(params.value).toLocaleString("en-IN");
      },
    },
    {
      field: "denomination",
      headerName: "Denomination",
      headerAlign: "center",
      align: "left",
      flex: 400,
      type: "string",
      editable: false,
      valueGetter: (value) => {
        if (
          value.row.toReceiptAmt !== 0 &&
          value.row.toReceiptAmt - value.row.fromReceiptAmt >= 100000
        ) {
          return "PER LAKH";
        } else if (
          value.row.toReceiptAmt !== 0 &&
          value.row.toReceiptAmt - value.row.fromReceiptAmt >= 0
        ) {
          return "PER RECEIPT";
        }
      },
    },
    {
      field: "icon",
      headerName: "",
      headerAlign: "center",
      align: "left",
      flex: 25,
      type: "number",
      disableColumnMenu: true,
      editable: false,
      renderCell: (params) => {
        return (
          <Tooltip title="Delete">
            <Delete
              onClick={() => {
                deleteSelectedRow(params);
              }}
            ></Delete>
          </Tooltip>
        );
      },
    },
  ];
  const [page, setPage] = React.useState(1);
  const rowsPerPage = 10;
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);
  const [enableAddButton, setEnableAddButton] = useState(true);
  const [gridVisible, setGridVisible] = useState(false);
  const [savedDialogOpen, setSaveDialogOpen] = useState(false);
  const [cashSavedDialogOpen, setCashSavedDialogOpen] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [historySet, setHistorySet] = useState([]);
  const [lastModifiedBy, setLastModifiedBy] = useState("");
  const handleSearch = () => {
    setEffectiveDateIsTouched(true);
    if (effectiveDateIsValid) {
      getSavedData();
    }
  };

  const getModifiedData = (modifiedData) => {
    let modifiedMap = {};
    modifiedData.forEach(function (key) {
      modifiedMap[key["fromReceiptAmt"]] =
        key["toReceiptAmt"] + key["cashHandlingCharges"] + key["denomination"];
    });
    return modifiedMap;
  };

  const getSavedData = async () => {
    try {
      const response = await axios.post(
        "/cashHandlingCharges/getByEffectiveDate",
        { effectiveDate: new Date(effectiveDate).toLocaleDateString("fr-FR") }
      );
      if (response.data) {
        setDatarows(response.data);
        setLastModifiedBy(response.data[0]["lastUpdatedBy"]);
        setPage(0);
        setModifiedmap(getModifiedData(response.data));
      }
    } catch {
      console.log("Network Error");
    }
    setGridVisible(true);
  };
  const clearButtonClickHandler = () => {
    setEffectiveDateIsTouched(false);
    setGridVisible(false);
    let newRow = {
      id: 0,
      fromReceiptAmt: 0,
      toReceiptAmt: "",
      cashHandlingCharges: "",
      denomination: "",
    };
    let newList = [];
    newList.push(newRow);
    setEffectiveDate(null);
    setDatarows(newList);
    setEffectiveDateIsTouched(false);
  };

  const onHistoryPreviewBtnClick = async () => {
    let previewColumns = [];
    previewColumns.push({
      field: "effectiveDate",
      headerName: "Effective Date",
      headerAlign: "center",
      align: "left",
      flex: 270,
      editable: false,
      filterable: false,
    });
    const filteredColumns = columns.filter(
      (col) => col.field !== "id" && col.field !== "icon"
    );
    previewColumns = previewColumns.concat(filteredColumns);
    previewColumns = previewColumns.map((col) => {
      col.editable = false;
      col.filterable = false;
      return col;
    });
    setCashHandlingRecordsOverviewGridColumns(previewColumns);
    const response = await axios.post(
      "/cashHandlingCharges/findAllCashHangesChargesList"
    );
    let records = response.data;
    records = records.map((record, index) => {
      record.id = index;
      record.effectiveDate = dayjs(new Date(record.effectiveDate)).format(
        "DD/MM/YYYY"
      );
      return record;
    });
    setCashHandlingRecordsOverviewGridRows(records);
    setTimeout(() => {
      setCashHandlingRecordsOverviewDlg(true);
    }, 500);
  };

  const valiateTosave = () => {
    if (doCheckIsDataValidated()) {
      setSaveDialogOpen(true);
    } else {
      setSaveDialogOpen(false);
      setErrorDialogOpen(true);
    }
  };
  const doCheckIsDataValidated = () => {
    let saveFlag = true;
    let lastReceiptAmount = 0;
    datarows.forEach((value, index) => {
      if (
        lastReceiptAmount <= value["fromReceiptAmt"] &&
        value["fromReceiptAmt"] < value["toReceiptAmt"] &&
        value["cashHandlingCharges"] >= 0
      ) {
        lastReceiptAmount = value["toReceiptAmt"];
      } else {
        saveFlag = false;
      }
    });
    return saveFlag;
  };
  const handleCellChangedEvent = (event) => {
    let changedAmount = event.row
      ? event.row.fromReceiptAmt
      : datarows[event.id]["fromReceiptAmt"];
    if (
      event.field === "toReceiptAmt" &&
      event.value &&
      event.value <= changedAmount &&
      datarows[event.id + 1] &&
      datarows[event.id + 1]["fromReceiptAmt"] <= event.value
    ) {
      setSnackBarMessage("This range value is already exist");
      setShowSnackBar(true);
      datarows[event.id][event.field] = event.value;
      if (event.field === "toReceiptAmt") {
        datarows[event.id][event.field] = Math.floor(event.value);
      }
    } else {
      datarows[event.id][event.field] = event.value;
      if (event.field === "cashHandlingCharges") {
        datarows[event.id][event.field] = Math.floor(event.value);
      }
      if (event.field === "toReceiptAmt") {
        if (event.field === "toReceiptAmt") {
          datarows[event.id][event.field] = Math.floor(event.value);
        }
        datarows[event.id]["denomination"] =
          event.value - datarows[event.id]["fromReceiptAmt"] >= 100000
            ? "PER LAKH"
            : "PER RECEIPT";
      }
      setShowSnackBar(false);
    }
    setDatarows(datarows);
    setSaveDisabled(
      JSON.stringify(modifiedMaps) === JSON.stringify(getModifiedData(datarows))
    );
    setHistorySet((previeous) => [
      ...previeous,
      datarows[event.id]["toReceiptAmt"],
    ]);
    if (event.field !== "cashHandlingCharges") {
      if (
        datarows[event.id + 1] &&
        datarows[event.id + 1]["fromReceiptAmt"] - 1 !== event.value
      ) {
        deleteSelectedRow({ id: event.id + 1 });
      }
    }
  };

  const discardChange = () => {
    setSaveDisabled(true);
    setGridVisible(false);
    setDiscardDialogOpen(false);
    setDatarows([]);
    setEffectiveDate(discardDateValue);
    addNewRow();
  };
  const saveDialogCloseAction = (event) => {
    if (event.key) {
      if (event.key === "Escape" || event.keyCode === 27) {
        setSaveDialogOpen(false);
      }
    } else {
      if (event.currentTarget.type && event.currentTarget.type === "button") {
        setSaveDialogOpen(false);
      } else {
        setSaveDialogOpen(true);
      }
    }
  };
  const closeDialogAction = (event) => {
    if (event.key) {
      if (event.key === "Escape" || event.keyCode === 27) {
        setDiscardDialogOpen(false);
        setEffectiveDate(prevEffectiveDate);
        setDueValidDateToError(false);
      }
    } else {
      if (event.currentTarget.type && event.currentTarget.type === "button") {
        setDiscardDialogOpen(false);
        setEffectiveDate(prevEffectiveDate);
        setDueValidDateToError(false);
      } else {
        setDiscardDialogOpen(true);
      }
    }
  };
  const successDialogCloseAction = (event) => {
    if (event.key) {
      if (event.key === "Escape" || event.keyCode === 27) {
        setCashSavedDialogOpen(false);
        setSaveDialogOpen(false);
      }
    }
  };
  const errorDialogCloseAction = (event) => {
    if (event.key) {
      if (event.key === "Escape" || event.keyCode === 27) {
        setErrorDialogOpen(false);
        setSaveDialogOpen(false);
      }
    }
  };
  const addNewRow = () => {
    if (datarows.length === 0) {
      let newRow = {
        id: 0,
        fromReceiptAmt: 0,
        toReceiptAmt: 0,
        cashHandlingCharges: 0,
        denomination: "",
      };
      setDatarows((prevRows) => [...prevRows, newRow]);
    } else {
      if (
        datarows[datarows.length - 1]["toReceiptAmt"].toString() &&
        datarows[datarows.length - 1]["toReceiptAmt"] > 0 &&
        datarows[datarows.length - 1]["fromReceiptAmt"].toString() &&
        datarows[datarows.length - 1]["cashHandlingCharges"].toString()
      ) {
        let newRow = {
          id: datarows.length,
          fromReceiptAmt: !datarows[datarows.length - 1]
            ? 0
            : datarows[datarows.length - 1]["toReceiptAmt"] + 1,
          toReceiptAmt: 0,
          cashHandlingCharges: 0,
          denomination: "",
        };
        setDatarows((prevRows) => [...prevRows, newRow]);
      }
    }
  };
  const deleteSelectedRow = (param) => {
    let toAmountValue = -1;
    let newRow = [];
    let count = 0;
    datarows.forEach((data, index) => {
      if (param.id !== data.id) {
        if (data["fromReceiptAmt"] - 1 === toAmountValue) {
          toAmountValue = data["toReceiptAmt"];
        } else {
          data["fromReceiptAmt"] = toAmountValue + 1;
          toAmountValue = data["toReceiptAmt"];
        }
        data["id"] = count++;
        newRow.push(data);
      }
    });
    setDatarows(newRow);
    setSaveDisabled(newRow.length === 0);
  };
  return (
    <>
      <div style={{ minHeight: "calc(100vh - 108px)" }}>
        <Grid
          container
          spacing={2}
          sx={{
            width: "calc(100% - 8px)",
            margin: "unset",
          }}
        >
          <AccordianContainer
            id="accord-jv"
            title="Cash Handling Charges"
            initialOpen={true}
          >
            <Box id="accord-box-jv-create" component="form" validate="true">
              <Grid item container spacing={1}>
                <Grid
                  id="grid-container"
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={3}
                  xl={3}
                ></Grid>
                <Grid
                  id="grid-container"
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={3}
                  xl={3}
                >
                  <CustomDateField
                    required={true}
                    label="Effective Date"
                    id="effectiveDate"
                    variant="standard"
                    value={effectiveDate}
                    type="text"
                    disablePast={true}
                    maxDate={new Date().setDate(
                      new Date().getDate() + maxDateFromValue
                    )}
                    placeholder="Voucher Date"
                    onChange={(event) => {
                      setEffectiveDateIsTouched(true);
                      if (!saveDisabled) {
                        setEffectiveDate(event ? new Date(event) : null);
                        setDiscardDateValue(new Date(event));
                        setDiscardDialogOpen(true);
                      } else {
                        setEffectiveDate(event ? new Date(event) : null);
                        setEnableAddButton(false);
                        setSaveDisabled(true);
                        setGridVisible(false);
                        setPrevEffectiveDate(event ? new Date(event) : null);
                      }

                      const newDateValue = `${new Date(event).getFullYear()}/${
                        new Date(event).getMonth() + 1 > 9
                          ? new Date(event).getMonth() + 1
                          : "0" + new Date(event).getMonth() + 1
                      }/${
                        new Date(event).getDate() > 9
                          ? new Date(event).getDate()
                          : "0" + new Date(event).getDate()
                      }`;

                      const maxValue = new Date().setDate(
                        new Date().getDate() + maxDateFromValue
                      );
                      const maxDateValue = `${new Date(
                        maxValue
                      ).getFullYear()}/${
                        new Date(maxValue).getMonth() + 1 > 9
                          ? new Date(maxValue).getMonth() + 1
                          : "0" + new Date(maxValue).getMonth() + 1
                      }/${
                        new Date(maxValue).getDate() > 9
                          ? new Date(maxValue).getDate()
                          : "0" + new Date(maxValue).getDate()
                      }`;
                      const specialAccessMaxFlag = newDateValue <= maxDateValue;
                      specialAccessMaxFlag
                        ? setDueValidDateToError(false)
                        : setDueValidDateToError(true);
                    }}
                    onBlur={() => {
                      setEffectiveDateIsTouched(true);
                    }}
                  />

                  {effectiveDateEmpty ? (
                    <p className="error">Please Select effective Date</p>
                  ) : effectiveDateHasError ? (
                    <p className="error">Please Enter Valid effective Date</p>
                  ) : (
                    dueValidDateToError && (
                      <p className="error">Please Enter Valid Date</p>
                    )
                  )}
                </Grid>
                <Grid
                  id="grid-container"
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={3}
                  xl={3}
                >
                  <Box
                    sx={{
                      margin: "32px 4px 0px 4px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Tooltip title="Ctrl+F" placement="top">
                      <Button
                        sx={{
                          fontWeight: "bold",
                          cursor: "pointer",
                          height: "2rem",
                        }}
                        variant="contained"
                        onClick={(event) => handleSearch()}
                        ref={searchButtonRef}
                      >
                        Go
                      </Button>
                    </Tooltip>
                    <Tooltip title="Ctrl+D" placement="top">
                      <Button
                        sx={{
                          marginLeft: "8px",
                          color: "white",
                          backgroundColor: "black",
                          fontWeight: "bold",
                          cursor: "pointer",
                          height: "2rem",
                        }}
                        onMouseOver={({ target }) => {
                          target.style.backgroundColor = "black";
                          target.style.color = "white";
                        }}
                        variant="contained"
                        onClick={() => clearButtonClickHandler()}
                        ref={clearRef}
                      >
                        Clear
                      </Button>
                    </Tooltip>
                    <Tooltip title="History" placement="top">
                      <Button
                        sx={{
                          fontWeight: "bold",
                          cursor: "pointer",
                          height: "2rem",
                          marginLeft: "8px",
                        }}
                        variant="contained"
                        onClick={() => onHistoryPreviewBtnClick()}
                      >
                        <History fontSize="small" />
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </AccordianContainer>
          {gridVisible && (
            <AccordianContainer
              id="accord-jv"
              title="Amount Details"
              initialOpen={true}
              sx={{ margin: "8px !important" }}
            >
              <>
                <div
                  style={{
                    direction: "rtl",
                    marginBottom: "4px",
                  }}
                >
                  <Tooltip title="Ctrl+S" placement="top">
                    <CustomButton
                      disabled={saveDisabled}
                      sx={{
                        marginLeft: "8px",
                        color: "white",
                        backgroundColor: "#004a92",
                        fontWeight: "bold",
                        height: "2rem",
                      }}
                      // onMouseOver={({ target }) => {
                      //   target.style.backgroundColor = "#004a92";
                      //   target.style.color = "white";
                      // }}
                      variant="contained"
                      onClick={valiateTosave}
                      ref={saveRef}
                    >
                      {"Save"}
                    </CustomButton>
                  </Tooltip>
                  <Tooltip title="Ctrl+A" placement="top">
                    <CustomButton
                      sx={{
                        marginLeft: "1rem",
                        color: "white",
                        backgroundColor: "#004a92",
                        fontWeight: "bold",
                        height: "2rem",
                      }}
                      disabled={enableAddButton}
                      onMouseOver={({ target }) => {
                        target.style.backgroundColor = "#004a92";
                        target.style.color = "white";
                      }}
                      variant="contained"
                      onClick={() => addNewRow()}
                      ref={addRowRef}
                    >
                      +
                    </CustomButton>
                  </Tooltip>
                </div>
                <CustomDataGrid
                  noDataMessage="No Data"
                  noDataOnFilterMessage="No Data on Applied Filter"
                  rows={datarows}
                  columns={columns}
                  pageSize={10}
                  pageSizeOptions={[10]}
                  gridLazyLoad={() => {}}
                  rowHeight={40}
                  gridHeight={
                    datarows.length < 5 && datarows.length !== 0
                      ? datarows.length * 40 + 130
                      : 305
                  }
                  onCellEditCommit={(event) => handleCellChangedEvent(event)}
                  onCellFocusOut={(event) => handleCellEditDisable(event)}
                  onCellKeyDown={(event, param) => {
                    (param.key === "e" ||
                      param.key === "E" ||
                      param.key === ".") &&
                      param.preventDefault();
                  }}
                  isCellEditable={() => {}}
                />
              </>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "18px",
                }}
              ></Box>
            </AccordianContainer>
          )}
        </Grid>
        <CustomConfirmationDialog
          dialogOpen={savedDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Confirmation</Typography>
          }
          dialogContent={"Save Cash Handling Charges Details ?"}
          hideCancelButton={false}
          okButtonName={"OK"}
          cancelButtonName={"Cancel"}
          onOkClick={() => {
            onSaveButtonClickHandler();
          }}
          onDialogClose={saveDialogCloseAction}
        />{" "}
        <CustomConfirmationDialog
          dialogOpen={discardDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Confirmation</Typography>
          }
          dialogContent={"Are you sure want to discard changes ?"}
          hideCancelButton={false}
          okButtonName={"OK"}
          cancelButtonName={"Cancel"}
          onOkClick={() => {
            discardChange();
          }}
          onDialogClose={closeDialogAction}
        />
        <CustomConfirmationDialog
          dialogOpen={cashSavedDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Information</Typography>
          }
          dialogContent={
            <Typography sx={{ fontSize: "1rem" }}>
              Cash Handling Charges Saved Successfully.
            </Typography>
          }
          hideCancelButton={true}
          onDialogClose={successDialogCloseAction}
          okButtonName={"OK"}
          cancelButtonName={""}
          onOkClick={() => window.location.reload()}
        />
        <CustomConfirmationDialog
          dialogOpen={errorDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Error</Typography>
          }
          dialogContent={
            <>Range is not properly entered/Cash handling charge cant't be 0</>
          }
          hideCancelButton={true}
          onDialogClose={errorDialogCloseAction}
          okButtonName={"OK"}
          cancelButtonName={""}
          onOkClick={() => setErrorDialogOpen(false)}
        />
        <Dialog open={cashHandlingRecordsOverviewDlg} fullScreen>
          <DialogTitle>
            <h4>Cash Handling Charges Records Overview</h4>
          </DialogTitle>
          <DialogContent>
            <CustomDataGrid
              noDataMessage="No Data"
              noDataOnFilterMessage="No Data on Applied Filter"
              rows={cashHandlingOverviewGridRows}
              columns={cashHandlingOverviewGridColumns}
              rowHeight={40}
              pageSize={10}
              pageSizeOptions={[5]}
              gridLazyLoad={() => {}}
              gridHeight={window.innerHeight - 200}
              isCellEditable={() => {}}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setCashHandlingRecordsOverviewDlg(false);
              }}
            >
              CLOSE
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <CustomSnackBar
        showSnackbar={showSnackBar}
        autoHideDuration={5000}
        onClose={() => {
          setShowSnackBar(false);
        }}
        message={snackBarMessage}
        severity="error"
      />
      <StlapFooter />
    </>
  );
};
export default CashHandlingCharge;
